<template>
    <el-container>
        <el-header class="header">
            <div class="header-normal">
                <el-menu class="menu" mode="horizontal"
                         :ellipsis="false"
                         active-text-color="#FF6900"
                         popper-class="menu-popper"
                         :show-timeout="150"
                         :hide-timeout="150"
                         :persistent="false"
                         :popper-offset="10"
                         :default-active="activeIndex">
                    <div class="logo background"></div>
                    <template v-for="(menu, index) in menuList" :key="index">
                        <el-sub-menu :teleported="false"
                                     class="menu-item"
                                     :popper-offset="0"
                                     v-if="menu.list !== null && menu.list.length > 0"
                                     :index="index.toString()">
                            <template #title>
                                <div :class="['menu-item__title', activeIndex === index.toString() ? 'is-active' : '']" @click="changeActiveIndex(menu, index, 1, 0 ,0 ,0)">{{ menu.name }}</div>
                            </template>
                            <div v-if="menu.list !== null">
                                <div :class="['menu-item__content', autoLayout(menu.list)]">
                                    <div v-for="(item, cIndex) in menu.list" :key="cIndex" :class="[item.name === null ? 'no-padding' : '', 'child-view']">
                                        <menu-child v-if="item.name" :list="item === null ? {} : item" @activeLevel="changeActiveIndex" :childIndex="cIndex" :parentActiveIndex="index"></menu-child>
                                    </div>
                                </div>
                            </div>
                        </el-sub-menu>
                        <el-menu-item v-else class="menu-item" :index="index.toString()" @click="changeActiveIndex(menu, index, 1, 0 ,0 ,0)">
                            <span class="menu-item__title">{{ menu.name }}</span>
                        </el-menu-item>
                    </template>
                    <div class="search">
                        <span>4000-848-868</span>
                        <div class="search-logo background" @click="handleSearch"></div>
                    </div>
                </el-menu>
            </div>
        </el-header>
        <el-main class="main">
            <router-view :key="$route.fullPath"></router-view>
        </el-main>
        <el-footer class="footer">
            <div class="footer-top">
                <div class="logo background footer"></div>
                <div class="search" v-if="false">
                    <el-input v-model="input" placeholder="placeholder"></el-input>
                </div>
            </div>
            <div class="footer-center">
                <div class="footer-nav">
                    <div class="nav-content" v-for="(nav, index) in footerList" :key="index">
                        <div class="nav-item" @click="handleClick(nav, 1)">{{ nav.name }}</div>
                        <div class="nav-item" v-for="(item, cIndex) in nav.list" :key="cIndex" @click="handleClick(item, 2)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="footer-tel">
                    <div class="tel-info">
                        <span>联系方式</span>
                        <span>服务热线</span>
                        <span>4000-848-868</span>
                        <span>7*24h</span>
                        <div class="qcode background"></div>
                        <span>中协公众号</span>
                        <div class="button">
                            关注中协 获取资料
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <span>Copyright@2001-2025中协智能</span>
                <span>苏ICP备15013641号</span>
                <span @click="handleLawClick" style="cursor: pointer;">法律声明</span>
            </div>
        </el-footer>
    </el-container>
</template>

<script>
    import { useStore } from 'vuex';
    import { useRouter} from 'vue-router'
    import store from "@/store"
    import mixin from  "@/mixin"
    import {getContentById, getMenuTree, getFooterMenuList, labelList} from "@/common/api"
    import newsVue from "../components/newsVue"
    import cardVue from "../components/cardVue";
    import listVue from "../components/listVue";
    import aboutVue from "@/components/aboutVue"
    import MenuChild from "../components/menuChild";
    import {ElMessage} from "element-plus";
    import router from "../route";
    import productVue from "@/components/ceshiVue";
    import searchVue from "@/components/searchVue";
    import coreVue from "@/components/coreVue";
    import {findItemRecursive} from "@/common/urtils";
    export default {
        name: "menuPage",
        components: {
            MenuChild,
        },
        data() {
            return {
                store: useStore(),
                route: useRouter(),
                router: null,
                showComponent: true,
                contentId: "",
                childrenList: [],
                menuSort: 0,
                content: {},
                component: "homePage",
                footerList: [],
                menuList: [],
                activeIndex: "0",
                backgroundColor: "#FFFFFF",
                childList: [
                    { name: '日常广播' },
                    { name: '考务广播' },
                    { name: '应急广播' },
                    { name: '相控阵防扰民' },
                    { name: '导览广播' },
                    { name: '社区云广播' },
                    { name: '防霸凌广播' },
                    { name: '紧急（消防）广播' }
                ],
                bannerList: [],
                menuLevel: 1,
                routeList: [],
            }
        },
        mixins: [mixin],
        computed: {
            key() {
                return new Date().getMilliseconds()
            }
        },
        watch: {
            '$route'() {
                window.scrollTo(0, 0)
                window.scrollTo({
                    top: 0
                })
                if(new URL(location.href).searchParams.get('activeIndex')){
                    this.activeIndex = new URL(location.href).searchParams.get('activeIndex')
                }
            }
        },
        methods: {
            handleLawClick() {
                router.push({
                    path: '/cvi/legalnotice'
                })
            },
            autoLayout(data) {
                let result = data.some(e=> e.list !== null && e.list.length > 0);
                return result ? 'grid' : 'flex'
            },
            handleSearch() {
                router.push({
                    path: '/cvi/home/search/view'
                })
            },
            handleSeeDetail(id) {
                this.content = {};
                this.component = "newsVue"
                getContentById(id).then(res=> {
                    if(res.success) {
                        this.component = "newsVue"
                        this.content = res.data
                    }else {
                        ElMessage.error("获取数据失败！")
                    }
                })

            },
            handleClick(item, level) {
                let parentId = level === 1 ? item.id : item.parentId;
                let activeIndex = this.store.state.menuList.findIndex(e=>e.id === parentId)
                router.push({
                    path: item.route,
                    query: {
                        menuId: item.id,
                        parentId: parentId,
                        activeIndex: activeIndex,
                        activeTag: 0,
                        level: level,
                        activeChildCard: 0
                    }
                })
            },
            treeToArr(tree) {
                let res = [];
                function dfs(treeArr) {
                    for (const treeItem of treeArr) {
                        const temp = {
                            id: treeItem.id,
                            name: treeItem.name,
                            route: treeItem.route,
                            type: treeItem.type,
                            parentId: treeItem.parentId,
                        };
                        res.push(temp);
                        if (treeItem.list !== null) {
                            dfs(treeItem.list);
                        }
                    }
                }
                dfs(tree);
                return res.sort((a, b) => a.id - b.id);
            },
            setAutoRouter(data) {
                const routes = router.getRoutes()
                const listData = this.treeToArr(data)
                if(!routes.some(e=>e.toString() === "/cvi/home/article/view")) {
                    router.addRoute({path: "/cvi/home/article/view", component: newsVue})
                }
                if(!routes.some(e=>e.toString() === "/cvi/home/search/view")) {
                    router.addRoute({path: "/cvi/home/search/view", component: searchVue})
                }
                // 先判断是否存在session动态路由数据
                listData.forEach(e=>{
                    let result = routes.some(item=> item === e.route)
                    if(!result) {
                        if(e.type === 2) {
                            router.addRoute({path: e.route, component: cardVue})
                        }else if(e.type === 3) {
                            router.addRoute({path: e.route, component: listVue})
                        }else if(e.type === 4) {
                            router.addRoute({path: e.route, component: productVue})
                        }else if(e.type === 0) {
                            router.addRoute({path: e.route, component: newsVue})
                        }else if(e.type === 5) {
                            router.addRoute({path: e.route, component: aboutVue})
                        }else if(e.type === 6) {
                            router.addRoute({path: e.route, component: coreVue})
                        }
                    }
                })
            },
            setMenuTree(data) {
                this.menuList = data
            },
            restorePage() {
                const pathname = location.pathname
                const level = new URL(location.href).searchParams.get('level')
                const activeTag = new URL(location.href).searchParams.get('activeTag')
                const type = new URL(location.href).searchParams.get('type')
                const activeIndex = new URL(location.href).searchParams.get('activeIndex')
                const parentId = new URL(location.href).searchParams.get('parentId')
                const activeChildCard = new URL(location.href).searchParams.get('activeChildCard')
                const pageType = new URL(location.href).searchParams.get('pageType')
                if(new URL(location.href).searchParams.get('menuId')) {
                    this.activeIndex = activeIndex;
                    const menuId = new URL(location.href).searchParams.get('menuId')
                    router.replace({
                        path: pathname,
                        query: {
                            menuId: menuId,
                            level: level,
                            activeTag: activeTag,
                            activeIndex: activeIndex,
                            parentId: parentId,
                            activeChildCard: activeChildCard
                        }
                    })
                }else if(new URL(location.href).searchParams.get('newId')){
                    const newId = new URL(location.href).searchParams.get('newId')
                    router.replace({
                        path: pathname,
                        query: {
                            newId: newId,
                            activeTag: activeTag,
                            activeIndex: activeIndex,
                            type: type,
                            parentId: parentId,
                            activeChildCard: activeChildCard,
                            pageType: pageType
                        }
                    })
                }else {
                    const pathname = location.pathname
                    const dix = this.menuList.findIndex(e=>e.route === pathname)
                    this.activeIndex = dix.toString();
                    router.replace({
                        path: pathname
                    })
                }
            },
            changeActiveIndex(data, index, level, type, childIndex, activeChildCard) {
                setTimeout(()=>{
                    this.activeIndex = index.toString();
                    console.log(data);
                    if(data.isContent === 0) {
                        router.push({
                            path: data.route,
                            query: {
                                menuId: data.id,
                                level: level,
                                activeTag: level === 1 ? 0 : childIndex,
                                activeIndex: this.activeIndex,
                                parentId: this.menuList[this.activeIndex].id,
                                activeChildCard: activeChildCard
                            }
                        })
                    }else {
                        router.push({
                            path: `/cvi/home/article/view`,
                            query: {
                                newId: data.id,
                                type: type,
                                activeTag: level === 1 ? 0 : childIndex,
                                activeIndex: this.activeIndex,
                                parentId: this.menuList[this.activeIndex].id,
                                activeChildCard: activeChildCard
                            }
                        })
                    }
                },80)
            },
            getInitData() {
                // 初始化页面导航、动态路由及首页数据处理
                getMenuTree().then(res => {
                    if(res.success) {
                        this.menuList = res.data
                        sessionStorage.setItem('menuList', JSON.stringify(this.menuList));
                        store.commit('storageList', this.menuList)
                        this.setAutoRouter(this.menuList)
                        labelList().then(res=> {
                            if(res.success) {
                                sessionStorage.setItem('labelList', JSON.stringify(res.data));
                            }else {
                                ElMessage.error(res.msg)
                            }
                        }).catch(()=>{
                            ElMessage.error("获取标签列表失败,请重试")
                        })
                    }else {
                        ElMessage.error(res.msg)
                    }
                }).catch(()=>{
                    ElMessage.error("获取导航栏菜单失败，请刷新页面重试!")
                })
            },
            setFooterMenu() {
                getFooterMenuList().then(res=> {
                    if(res.success) {
                        this.footerList = res.data
                    }else {
                        ElMessage.error(res.msg)
                    }
                }).catch(()=>{
                    ElMessage.error("获取导航栏菜单失败，请刷新页面重试!")
                })
            }
        },
        created() {
            Promise.all([this.setFooterMenu()])
            if(sessionStorage.getItem('menuList')){
                this.showHeader = true;
                let menuList = JSON.parse(sessionStorage.getItem('menuList'))
                store.commit('storageList', menuList)
                this.setMenuTree(menuList)
                this.setAutoRouter(menuList)
                setTimeout(()=>{
                    this.restorePage();
                },80)
            }else {
                this.getInitData();
            }
        },
        mounted() {
            window.addEventListener('popstate',()=>{
                window.scrollBy(0, 0);
            })
            window.addEventListener('beforeunload',()=>{
                window.scrollBy(0, 0);
            })
        }
    }
</script>

<style lang="less" scoped>
    .background {
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-size: cover !important;
    }
    .header {
        position: fixed;
        top: 0;
        padding: 0;
        z-index: 888;
        height: 65px;
        background-color: #FFFFFF;
        width: 100%;
        transition: ease 0.4s;
        &.header-scrolled {
            //height: 40px;
        }
        //border-bottom: 1px solid red;
        .header-normal {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .logo {
                width: 173px;
                margin-right: auto;
                height: 34px;
                flex-shrink: 0;
                background-image: url("~@/assets/company-footer-logo.png");
            }
            ::v-deep .menu {
                height: 100%;
                border-bottom: none;
                align-items: center;
                justify-content: center;
                background-color: transparent;
                width: 100%;
                padding: 0 186px;
                .menu-item {
                    padding: 0;
                    margin: 0 45px;
                    color: #333333;
                    font-weight: bold;
                    font-size: 16px;
                    &.el-sub-menu {
                        border-bottom: none;
                    }
                    .menu-item__title {
                        &:hover{
                            color: #FF6900 !important;
                            .el-icon {
                                color: #FF6900;
                            }
                        }

                    }
                    .el-sub-menu__title {
                        padding: 0;
                        height: 100%;
                        color: #333333;
                        font-size: 16px;
                        border-bottom: none;
                        .el-sub-menu__icon-arrow {
                            display: none;
                        }
                        &:hover {
                            background-color: transparent;
                        }
                        .menu-item__title {
                            line-height: 63px;
                            height: 100%;
                            border-bottom: 2px solid transparent;
                        }
                        .is-active {
                            color: #FF6900;
                            font-weight: bold;
                            border-bottom-color: #FF6900;
                            &+.el-icon {
                                color: #FF6900;
                            }
                        }
                        .el-icon {
                            right: -16px;
                        }
                        &:hover{
                            .el-icon {
                                color: #FF6900;
                            }
                        }
                    }
                    &:hover, &:active, &:visited, &:focus {
                        background-color: transparent;
                        color: #333333;
                    }
                    &.is-active {
                        font-weight: bold;
                        border-bottom: 2px solid #FF6900;
                        .el-sub-menu__title {
                            border-bottom: none !important;
                        }
                    }
                }
            }
            .search {
                font-size: 16px;
                margin-left: auto;
                color: #FF6900;
                display: flex;
                align-items: center;
                flex-shrink: 0;
                .search-logo {
                    margin-left: 32px;
                    width: 24px;
                    cursor: pointer;
                    height: 24px;
                    background-image: url("~@/assets/home-search.png");
                }
            }
        }
    }
    .main {
        padding: 0;
        min-height: 100vh;
        overflow-y: hidden;
    }
    .footer {
        padding: 0;
        height: 662px;
        background: #F2F2F2;
        display: flex;
        flex-direction: column;
        .footer-top {
            height: 127px;
            border-bottom: 1px solid #666666;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            .logo {
                margin-left: 197px;
                width: 173px;
                height: 34px;
                margin-bottom: 28px;
                background-image: url("~@/assets/company-footer-logo.png");
                &.footer {
                    background-image: url("~@/assets/company-footer-logo.png");
                }
            }
            .search {
                width: 556px;
                margin-bottom: 20px;
                ::v-deep .el-input {
                    width: 361px;
                    height: 49px;
                    background: #666666;
                    .el-input__wrapper {
                        border: 1px solid #666666;
                        box-shadow: none;
                        border-radius: 0;
                    }
                }
            }
        }
        .footer-center {
            flex: 1;
            display: flex;
            align-items: center;
            .footer-nav {
                flex: 1;
                margin-left: 197px;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                .nav-content {
                    flex: 1;
                    .nav-item {
                        max-width: 140px;
                        cursor: pointer;
                        font-size: 14px;
                        color: #666666;
                        margin-bottom: 11px;
                        white-space: normal;
                        word-break: break-all;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        // 禁用自动添加浏览器前缀
                        /* autoprefixer: off */
                        display: -webkit-box;
                        -webkit-line-clamp: 1;// 代表文本超长最多显示2行，可自行调整最多显示的行数
                        -webkit-box-orient: vertical;
                        &:hover {
                            color: #ff6600 !important;
                        }
                        &:nth-of-type(1) {
                            font-size: 18px;
                            font-weight: bold;
                            flex-shrink: 0;
                            color: #333333;
                            margin-bottom: 24px;
                        }
                    }
                }
            }
            .footer-tel {
                height: 100%;
                width: 555px;
                border-left: 1px solid #666666;
                display: flex;
                align-items: center;
                .tel-info {
                    margin-left: 80px;
                    width: 200px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    color: #FF6900;
                    span {
                        font-size: 16px;
                        &:nth-of-type(1) {
                            margin-bottom: 20px;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        &:nth-of-type(2) {
                            position: relative;
                            padding-left: 24px;
                            display: flex;
                            align-items: center;
                            &::after {
                                left: 0;
                                position: absolute;
                                content: "";
                                background-image: url("~@/assets/home-tel-icon.png");
                                width: 18px;
                                height: 18px;
                                background-size: cover;
                            }
                        }
                        &:nth-of-type(3) {
                            font-weight: bold;
                            font-size: 22px;
                        }
                        &:nth-of-type(5) {
                            margin-top: 4px;
                            font-size: 16px;
                            color: #666666;
                        }
                    }
                    .qcode {
                        margin-top: 8px;
                        width: 100px;
                        height: 100px;
                        background-image: url("~@/assets/code-icon.png");
                    }
                    .button {
                        margin-top: 15px;
                        width: 180px;
                        height: 40px;
                        background: #FF6900;
                        color: #FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
        .footer-bottom {
            border-top: 1px solid #666666;
            height: 74px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
                color: #666666;
                line-height: 1;
                font-size: 14px;
                padding-right: 20px;
                margin-right: 20px;
                border-right: 1px solid #666666;
                &:nth-last-of-type(1){
                    padding-right: 0;
                    margin-right: 0;
                    border-right: none;
                }
            }
        }
    }
</style>
